export enum DuplicateProductErrorMode {
  Create = 'create',
  Update = 'update',
}

export interface IModalProps {
  isOpen: boolean;
  productName: string;
  mode?: DuplicateProductErrorMode;
  onClose: () => void;
  onProductView?: () => void;
  conflictField?: string;
}
